import React, { useEffect, useRef, useState, } from 'react';
import { ActivityIndicator, Dimensions, FlatList, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View, } from 'react-native';
import { ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import { Button } from '../../button/Button';
import { isFontMobile, isMobile, isMobileView } from '../../stack/utils';
import { addCommasToNumber } from '../utils';
import HeroSection from './HeroSection';
import { OtpInput } from "../OtpInput/OtpInput";
import AssetDetails from "../AssetDetails";
import { HeaderDefaultBase } from "../../header/HeaderDefault.Base";
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from "../NeedHelpDC";
const LoanForeclosure = ({ profileAction, stepperData, triggerAction, backAction, applyAction, modalState, continuePress, userName, height, creditLimit, sanctionedAmount, userData, pledgedData, error, showOtpModal, skipBankAction, needHelp, showConfirmationProp, counter, loading, showProcessInProgressCard, processInProgressData, description, inProgressProcessNavigateAction, inProgressType, isFromPledgeHistory, contactUsDetails, isFromJupiter, isLoanExpired, netPayable, }) => {
    // @ts-ignore
    let phoneNumber = userData.user.phoneNumber;
    const inputRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filtersSections, setFiltersSection] = useState([]);
    const [isErrorState, setIsErrorState] = useState(false);
    const [showPortfolioDetails, setShowPortfolioDetails] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [getCollateralLoader, setShowGetCollateralLoader] = useState(false);
    const [showForeclosureLoader, setShowForeClosureLoader] = useState(false);
    const [isViewDetailsClicked, setIsViewDetailsClicked] = useState(false);
    const [flatData, setFlatData] = useState([]);
    const [isBackClicked, setBackClicked] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [list, setList] = useState({});
    const [isProgressCardHeight, setInProgressCardHeight] = useState(0);
    useEffect(() => {
        if (inProgressType === "FORECLOSURE_BUSINESS_HOUR_CHECK") {
            if (isMobileView()) {
                setInProgressCardHeight(330);
            }
            else
                setInProgressCardHeight(290);
        }
        else {
            if (isMobileView()) {
                setInProgressCardHeight(370);
            }
            else
                setInProgressCardHeight(330);
        }
    }, [inProgressType]);
    const [showConfimation, setShowConfirmation] = useState(isLoanExpired);
    const [seconds, setSeconds] = useState(20);
    const [isRunning, setIsRunning] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [filterName, setFilterName] = useState('EQUITY');
    const [keyboardHeight, setKeyboardHeight] = useState(0);
    const [processInProgress, setProcessInProgress] = useState(false);
    const [isProceedToLoanClicked, setProceedToLoanClicked] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    let initialHeight = Dimensions.get('window').height;
    const mobHeight = Dimensions.get('window').height;
    useEffect(() => {
        setShowConfirmation(isLoanExpired);
    }, []);
    useEffect(() => {
        setButtonLoading(false);
        setShowForeClosureLoader(false);
        setShowModal(showOtpModal);
    }, [showOtpModal, error, modalState]);
    useEffect(() => {
        setProceedToLoanClicked(false);
        setShowConfirmation(false);
    }, []);
    useEffect(() => {
        if (showProcessInProgressCard === undefined) {
            setShowConfirmation(false);
        }
        else if (showProcessInProgressCard) {
            setShowConfirmation(false);
        }
    }, [showProcessInProgressCard]);
    useEffect(() => {
        setProcessInProgress(showProcessInProgressCard);
        if (showProcessInProgressCard) {
            setShowGetCollateralLoader(false);
            setShowConfirmation(false);
        }
        else {
            if (isFromPledgeHistory) {
                setShowConfirmation(false);
            }
            else if (showProcessInProgressCard !== undefined && isProceedToLoanClicked && !isViewDetailsClicked && !isBackClicked) {
                setShowConfirmation(true);
            }
            else if (isViewDetailsClicked && !isBackClicked) {
                setShowConfirmation(false);
            }
            setBackClicked(false);
        }
    }, [showProcessInProgressCard, getCollateralLoader, showConfimation, isProceedToLoanClicked, isFromPledgeHistory, isViewDetailsClicked, showPortfolioDetails]);
    useEffect(() => {
        setShowConfirmation(false);
        return () => {
            setShowForeClosureLoader(false);
            setShowConfirmation(false);
        };
    }, []);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    useEffect(() => {
        return () => {
            if (showProcessInProgressCard) {
                setProceedToLoanClicked(false);
                setShowConfirmation(false);
                setProcessInProgress(false);
            }
        };
    }, [showProcessInProgressCard, showConfimation]);
    useEffect(() => {
        console.warn("Show confirmation prop", showConfirmationProp);
        if (showConfirmationProp === false) {
            setShowConfirmation(false);
        }
    }, [showConfirmationProp, counter]);
    useEffect(() => {
        setFlatData(pledgedData);
        setShowGetCollateralLoader(false);
        let listObj = {
            eligibleAssetData: pledgedData,
            nonEligibleAssetData: []
        };
        setInitialData();
        setList(listObj);
    }, [pledgedData]);
    let eligibleFilters = [];
    useEffect(() => {
        if (error) {
            setIsErrorState(true);
        }
        else
            setIsErrorState(false);
    }, [error]);
    useEffect(() => {
        phoneNumber =
            Dimensions.addEventListener('change', handleResize);
        let listObj = {
            eligibleAssetData: pledgedData,
            nonEligibleAssetData: []
        };
        setInitialData();
        setList(listObj);
    }, []);
    const handleResize = () => {
        // Check the screen dimensions to determine if the virtual keyboard is open
        const { height } = Dimensions.get('window');
        if (height < initialHeight) {
            setKeyboardHeight(200);
        }
        else {
            setKeyboardHeight(0);
        }
    };
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        setShowConfirmation(isLoanExpired);
    }, []);
    const calForeclosureTitle = () => {
        let title = '';
        if (isLoanExpired) {
            title = 'Confirm loan closure';
        }
        else if (showConfimation) {
            title = 'Confirm closure';
        }
        else if (showPortfolioDetails) {
            title = 'Pledged mutual funds';
        }
        else
            title = 'Foreclose your loan';
        return title;
    };
    const _headerChild = () => {
        return (React.createElement(CustomHeader, { title: calForeclosureTitle(), needHelpAction: handleNeedHelp, hideNeedHelp: false, triggerAction: triggerAction, getbgColor: true, showNeedHelpNewArch: true, onPress: () => {
                setBackClicked(true);
                if (showConfimation && !isLoanExpired) {
                    setShowConfirmation(false);
                }
                else if (showPortfolioDetails) {
                    setShowPortfolioDetails(false);
                    setShowConfirmation(true);
                    setIsViewDetailsClicked(false);
                }
                else {
                    triggerAction({
                        ...backAction,
                        payload: {
                            value: (showConfimation || showPortfolioDetails) ? '' : 'MY_PROFILE'
                        }
                    });
                }
            } }));
    };
    const modalContentPresenter = () => {
        return returnOtpModal();
    };
    const handleStartStop = () => {
        setIsRunning((prevIsRunning) => !prevIsRunning);
    };
    const handleReset = () => {
        setSeconds(20);
        setIsRunning(true);
    };
    const processInProgressCard = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, flex: 1 }, activeOpacity: 1, onPress: () => { } },
            React.createElement(View, { style: { alignItems: 'center', alignContent: 'center', alignSelf: 'center' } },
                React.createElement(Icon, { name: IconTokens.Warning, size: IconSizeTokens.XXXXXXL }),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { label: `${processInProgressData}`, typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
            React.createElement(View, { style: {
                    borderRadius: 8,
                    backgroundColor: '#F1F3F5',
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    flexShrink: 1,
                    marginTop: 16
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: `${description}`, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: { marginTop: 24 } },
                inProgressType !== "FORECLOSURE_BUSINESS_HOUR_CHECK" && React.createElement(View, { style: { marginBottom: 12 } },
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "View transaction details", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            triggerAction({
                                ...inProgressProcessNavigateAction,
                                payload: {
                                    value: inProgressType
                                }
                            });
                            setProcessInProgress(false);
                        } })),
                React.createElement(Button, { fontFamily: FontFamilyTokens.Inter, typeDLS: ButtonTypeDLS.PRIMARY, fontSize: FontSizeTokens.SM, label: "Ok, got it!", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setProcessInProgress(false);
                    } }))));
    };
    const returnOtpModal = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1 }, activeOpacity: 1 },
            React.createElement(Typography, { label: 'Enter 6-digit OTP', fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night, lineHeight: 28, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    padding: 12,
                    display: 'flex',
                    borderRadius: 12,
                    borderWidth: 1,
                    borderColor: colorMapping[ColorTokens.Secondary_20],
                    backgroundColor: colorMapping[ColorTokens.Secondary_02],
                    flexDirection: 'row'
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        width: 40,
                        padding: 8,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 400,
                        backgroundColor: '#FFF'
                    } },
                    React.createElement(Icon, { name: IconTokens.MessageOtp, color: ColorTokens.Secondary_100 })),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column'
                    } },
                    React.createElement(Typography, { label: 'OTP sent to', fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Space, { size: SizeTypeTokens.XS }),
                    React.createElement(Typography, { label: `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, phoneNumber.length)}`, fontWeight: '500', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(OtpInput, { id: 'tf_loanForeclosure_otp', numberOfDigits: 6, ref: inputRef, editable: !showForeclosureLoader, onTextChange: async (text) => {
                        if (text.length === 6) {
                            setShowForeClosureLoader(true);
                            setIsErrorState(false);
                            if (continuePress) {
                                await triggerAction({
                                    ...continuePress,
                                    payload: {
                                        otp: text,
                                    },
                                });
                                setShowModal(false);
                                // setShowConfirmation(false)
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setShowForeClosureLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : colorMapping[ColorTokens.Primary_100], theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8 },
                        pinCodeTextStyle: { fontSize: 15 },
                        containerStyle: { width: 300 },
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: { marginTop: 6 } }),
                showForeclosureLoader && !isErrorState && React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                isErrorState && inputRef?.current?.clear(),
                isErrorState && (React.createElement(View, { style: {} },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: userName }))),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(View, { style: {
                        paddingTop: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            setShowTimer(true);
                            if (seconds === 0) {
                                //@ts-ignore
                                inputRef?.current?.clear();
                                handleReset();
                                if (applyAction) {
                                    triggerAction(applyAction);
                                }
                            }
                        } },
                        React.createElement(Typography, { id: 'txt_commonScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0
                                ? ColorTokens.Primary_100
                                : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))))));
    };
    const convertEpochToDate = (timeStamp) => {
        const date = new Date(timeStamp);
        // Define an array of month names
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        // Extract the day, month, and year from the date
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        // Create the formatted date string
        const formattedDate = `${day} ${month}, ${year}`;
        return formattedDate;
    };
    const convertEpochToShortDate = (timeStamp) => {
        const date = new Date(timeStamp);
        // Define an array of month names
        const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
        // Extract the day, month, and year from the date
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        // Create the formatted date string
        const formattedDate = `${day} ${month}, ${year}`;
        return formattedDate;
    };
    const confirmBodyChild = () => {
        return getCollateralLoader ? (React.createElement(View, { style: {
                // position: 'absolute',
                // left: 0,
                // right: 0,
                // top: 0,
                // bottom: 0,
                marginTop: 200,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
            } },
            React.createElement(ActivityIndicator, { size: "large", color: '#1434CB' }))) : (React.createElement(View, { style: { padding: 16 } },
            isLoanExpired && React.createElement(View, { style: { backgroundColor: 'white', borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 12, padding: 16, marginBottom: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: netPayable > 0 ? 'Overdue amount' : 'Outstanding amount', color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', color: netPayable > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(Typography, { label: `${addCommasToNumber(netPayable)}`, typeDLS: TypographyTypeDLS.H1B, color: netPayable > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night }))),
            React.createElement(View, { style: {
                    paddingTop: 18,
                    paddingBottom: 12,
                    marginHorizontal: -16,
                    marginTop: -16,
                    paddingHorizontal: 16,
                } },
                React.createElement(Typography, { label: 'Loan details', fontWeight: '700', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { backgroundColor: 'white', marginHorizontal: -16, paddingHorizontal: 16 } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: 16,
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: 'Loan account number', fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: userData.linkedCredits[0].lenderCreditId, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: {
                        height: 1,
                        marginVertical: 16,
                        backgroundColor: '#F1F3F5',
                    } }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: 'Loan amount', fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(userData.linkedCredits[0].actualLoanAmount), fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: {
                        height: 1,
                        marginTop: 16,
                        backgroundColor: '#F1F3F5',
                    } }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: 16,
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: 'End date', fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: convertEpochToDate(userData.linkedCredits[0].renewalDate), fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: {
                        height: 1,
                        marginTop: 16,
                        backgroundColor: '#F1F3F5',
                    } }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: 16,
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: 'Interest rate', fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: userData.linkedCredits[0].currentApplicableInterestRate + '%', fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: {
                        height: 1,
                        marginTop: 16,
                        backgroundColor: '#F1F3F5',
                    } })),
            React.createElement(View, { style: {
                    paddingTop: 30,
                    paddingBottom: 12,
                    marginHorizontal: -16,
                    marginTop: -16,
                    paddingHorizontal: 16,
                } },
                React.createElement(Typography, { label: 'Collateral details', fontWeight: '700', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    padding: 16,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    marginHorizontal: -16
                } },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Mutual fund value', fontWeight: '500', fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(userData.linkedCredits[0].totalValueOfAssetsPledged), fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                        setShowConfirmation(false);
                        setShowPortfolioDetails(true);
                        setIsViewDetailsClicked(true);
                    } },
                    React.createElement(Typography, { id: 'txt_loanForeclosure_viewDetails', label: 'View details', fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 24, color: ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(View, { style: { justifyContent: 'center', alignItems: 'center' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, color: ColorTokens.Primary_100 })))),
            React.createElement(View, { style: {
                    height: isMobile(getScreenType(Dimensions.get('window').width)) ? 100 : 100,
                    alignSelf: 'stretch',
                    marginHorizontal: -16,
                } })));
    };
    const setInitialData = () => {
        pledgedData.map((item) => {
            if (eligibleFilters.includes(item.assetSubType)) {
                // Do nothing basically
            }
            else {
                eligibleFilters.push(item.assetSubType);
            }
        });
        setFiltersSection(eligibleFilters);
    };
    const portfolioDetails = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: { backgroundColor: colorMapping[ColorTokens.Primary_05], padding: 16 } },
                React.createElement(View, { style: {
                        padding: 20,
                        borderRadius: 12,
                        borderWidth: 1,
                        backgroundColor: 'white',
                        borderColor: '#E7EBFA'
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Mutual fund value', fontWeight: '500', fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `₹${addCommasToNumber(userData.linkedCredits[0].totalValueOfAssetsPledged)}`, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })))),
            React.createElement(ScrollView, { style: Platform.OS !== "ios" ?
                    {
                        height: height - 210,
                        paddingHorizontal: 16,
                        paddingBottom: 16,
                    } :
                    {
                        height: height - 270,
                        paddingHorizontal: 16,
                        paddingBottom: 36
                    } },
                React.createElement(AssetDetails, { data: [selectedList], dataa: list, flatData: flatData, onFitlerSet: () => {
                        setShowFilter(true);
                        setFilterData(pledgedData.filter((item) => item.assetSubType === filtersSections[0]));
                        setFilterName(filtersSections[0]);
                    }, isFromEligible: true, triggerAction: triggerAction, height: height }))));
    };
    const ChecklistItem = ({ item, onPress }) => {
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        setSelectedList(data);
                        setFilterData(pledgedData.filter((item) => item.assetSubType === filterName));
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isinCode)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        let data = selectedList;
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        setSelectedList(data);
                        setFilterData(pledgedData.filter((item) => item.assetSubType === filterName));
                    }, style: { width: '100%', marginLeft: 8, paddingRight: 16 } },
                    React.createElement(Typography, { label: item.assetName, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Night })))));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList.length === 0) {
            let listObj = {
                eligibleAssetData: pledgedData,
                nonEligibleAssetData: []
            };
            setFlatData(filteredData);
            setList(listObj);
            setFlatData(pledgedData);
            return;
        }
        pledgedData.map((item) => {
            selectedList.includes(item.isinCode)
                ? filteredData.push(item)
                : null;
        });
        let listObj = {
            eligibleAssetData: filteredData,
            nonEligibleAssetData: []
        };
        setFlatData(filteredData);
        setList(listObj);
    };
    const _bodyChild = () => {
        // @ts-ignore
        // @ts-ignore
        // @ts-ignore
        return (React.createElement(View, { style: { padding: 16, backgroundColor: 'white' } },
            React.createElement(View, { style: {
                    height: 24,
                    backgroundColor: colorMapping[ColorTokens.Primary_05],
                    marginHorizontal: -16,
                    marginVertical: -16,
                } }),
            React.createElement(View, { style: {
                    alignContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(View, { style: { marginTop: 20, paddingTop: 20 } },
                    React.createElement(Typography, { label: 'Your credit line', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, null,
                    React.createElement(Text, { style: [styles.text, styles.textLayout] },
                        React.createElement(Text, { style: styles.text1Typo }, "\u20B9"),
                        React.createElement(Text, { style: styles.text2Typo }, 
                        //@ts-ignore
                        addCommasToNumber(userData.linkedCredits[0].actualLoanAmount)))),
                React.createElement(View, { style: { marginTop: 5, flexDirection: 'row' } }),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: "is available for", fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: " FREE ", fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: "till ", fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: convertEpochToShortDate(userData.linkedCredits[0].renewalDate), fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                React.createElement(HeroSection, null)),
            React.createElement(View, { style: {
                    height: 24,
                    backgroundColor: colorMapping[ColorTokens.Primary_05],
                    marginHorizontal: -16,
                    marginTop: 24,
                } }),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(Typography, { label: 'Foreclose your loan anytime without any hidden charges', fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, null,
                        React.createElement(View, { style: styles.outerCircle },
                            React.createElement(View, { style: styles.circle },
                                React.createElement(Typography, { label: '1', fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.White }))),
                        React.createElement(View, { style: styles.divider })),
                    React.createElement(View, { style: { marginLeft: 16 } },
                        React.createElement(Typography, { label: 'Raise a request for closure anytime', fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        marginTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: styles.outerCircle },
                            React.createElement(View, { style: styles.circle },
                                React.createElement(Typography, { label: '2', fontWeight: '500', fontSize: FontSizeTokens.XXS, lineHeight: 20, color: ColorTokens.White }))),
                        React.createElement(View, { style: styles.divider })),
                    React.createElement(View, { style: { marginLeft: 16 } },
                        React.createElement(Typography, { label: 'Make payments on existing dues', fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        marginTop: 2,
                        marginBottom: 16,
                    } },
                    React.createElement(View, { style: styles.outerCircle },
                        React.createElement(View, { style: styles.circle },
                            React.createElement(Typography, { label: '3', fontWeight: '500', fontSize: FontSizeTokens.XXS, lineHeight: 20, color: ColorTokens.White }))),
                    React.createElement(View, { style: { marginLeft: 16 } },
                        React.createElement(Typography, { label: 'We will approve the request to release\ncollateral within 1-2 business days', fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal })))),
            React.createElement(View, { style: {
                    backgroundColor: colorMapping[ColorTokens.Primary_05],
                    marginHorizontal: -16,
                } })));
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderTopWidth: 1,
                borderColor: '#F1F3F5',
                paddingHorizontal: -16,
                backgroundColor: 'white',
            } },
            React.createElement(View, { style: { margin: 16, paddingBottom: Platform.OS === "ios" ? 16 : 0 } },
                React.createElement(Button, { id: 'bt_loanForeclosure_Continue', type: !getCollateralLoader ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, loading: loading, label: showConfimation ? "Confirm loan closure" : 'Proceed to loan closure', onPress: () => {
                        if (showConfimation === false) {
                            if (skipBankAction) {
                                triggerAction(skipBankAction);
                            }
                            setProceedToLoanClicked(true);
                            setShowGetCollateralLoader(true);
                        }
                        else {
                            setProceedToLoanClicked(false);
                            setButtonLoading(true);
                            setIsErrorState(false);
                            if (applyAction) {
                                handleStartStop();
                                triggerAction(applyAction);
                            }
                        }
                    } }))));
    };
    const returnFilter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { height: Platform.OS === "ios" ? height - 25 : height - 45, zIndex: 1 } },
            React.createElement(View, null,
                React.createElement(HeaderDefaultBase, { title: 'Filters' })),
            React.createElement(View, { style: height ? {
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    ...Platform.OS === 'ios' && {
                        height: height ? height - 56 : '100%'
                    },
                    ...Platform.OS !== 'ios' && {
                        flex: 1
                    },
                } : {
                    flex: 1,
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: filtersSections, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                setFilterData(pledgedData.filter((items) => items.assetSubType === item));
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(View, { style: {
                        flex: 1,
                    } },
                    React.createElement(ScrollView, { nestedScrollEnabled: true, style: height ? {
                            flex: 1,
                            paddingBottom: Platform.OS === 'ios' ? 80 : 16,
                            paddingHorizontal: 16
                        } : { height: 550 } }, filterData.map((item) => {
                        return (React.createElement(View, null,
                            React.createElement(ChecklistItem, { item: item, onPress: () => {
                                } }),
                            React.createElement(View, { style: { backgroundColor: '#E4E7EC', height: 1 } })));
                    })),
                    React.createElement(View, { style: {
                            height: 56
                        } }))),
            React.createElement(View, { style: {
                    height: Platform.OS === 'ios' ? 76 : 88,
                    position: "absolute",
                    bottom: Platform.OS !== 'ios' ? -5 : 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    elevation: 5,
                    paddingTop: 16,
                    paddingBottom: 16,
                    paddingHorizontal: 16,
                    ...Platform.OS === "ios" && { paddingBottom: 6 }
                } },
                React.createElement(View, { nativeID: 'bt_pledgeMf_resetFilter', style: { flex: 0.5, marginRight: 8 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: "Reset filter", fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setSelectedList([]);
                            let listObj = {
                                eligibleAssetData: pledgedData,
                                nonEligibleAssetData: []
                            };
                            setFlatData(pledgedData);
                            setList(listObj);
                            return;
                        } })),
                React.createElement(View, { nativeID: 'bt_pledgeMf_apply', style: { flex: 0.5 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, label: "Apply", onPress: () => {
                            applyFilter();
                            setShowFilter(false);
                        } })))));
    };
    const renderMainBody = () => {
        return (React.createElement(View, { style: [styles.container, {
                    height: Platform.OS === "ios" ? height - 12 : height,
                    backgroundColor: showPortfolioDetails ? "white" : colorMapping[ColorTokens.Primary_05]
                }] },
            React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(View, { style: Platform.OS === 'ios' ? {
                        paddingTop: 8,
                        backgroundColor: showConfimation ? colorMapping[ColorTokens.Primary_05] : 'white'
                    } : {} }, _headerChild()),
                React.createElement(View, { style: [Platform.OS !== "ios" ? { height: showPortfolioDetails ? height - 49 : height - 110 } : {
                            height: height - 138
                        }] },
                    React.createElement(ScrollView, null, showConfimation
                        ? confirmBodyChild()
                        : showPortfolioDetails ? portfolioDetails() : _bodyChild())),
                !showPortfolioDetails && !processInProgress && React.createElement(View, { style: styles.footer }, _footerChild())),
            showModal && (React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 99,
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS !== "web" ? 350 : 300, width: '100%', closeFunction: () => {
                        setShowModal(false);
                        setShowForeClosureLoader(false);
                    }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, modalContentPresenter()))),
            processInProgress &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        bottom: -2,
                        zIndex: 99,
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isProgressCardHeight, width: '100%', closeFunction: () => {
                            setProcessInProgress(false);
                        }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS === 'ios' ? Dimensions.get('window').height + 5 : height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 506, routeId: "routeId", handleKeyboard: true }, processInProgressCard())),
            showFilter && React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 99,
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: true, height: height - 50, width: '100%', closeFunction: () => {
                        setIsErrorState(false);
                        setShowFilter(false);
                    }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS === 'ios' ? Dimensions.get('window').height + 5 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 506, routeId: "routeId", handleKeyboard: true }, returnFilter())),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
    };
    return renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
        ...Platform.OS === "ios" && {
            height: isMobile(getScreenType(Dimensions.get('window').width))
                ? Dimensions.get('window').height - 70
                : Dimensions.get('window').height - 114,
        }
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        width: '100%',
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 1,
        width: '100%',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    circle: {
        width: 18,
        height: 18,
        borderRadius: 24 / 2,
        backgroundColor: '#98A2B3',
        justifyContent: 'center',
        alignItems: 'center',
    },
    outerCircle: {
        width: 24,
        height: 24,
        borderRadius: 24 / 2,
        backgroundColor: '#F1F3F5',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        fontSize: 32,
        lineHeight: 40,
        textShadowColor: 'rgba(8, 127, 58, 0.12)',
        textShadowOffset: {
            width: 2,
            height: 2,
        },
        textShadowRadius: 0,
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
    text2Typo: {
        fontWeight: '700',
        color: '#00682C',
    },
    frameLayout: {
        borderWidth: 1,
        alignSelf: 'stretch',
    },
    textLayout: {},
    vectorGroupFlexBox: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    groupChildLayout1: {
        height: 24,
        width: 24,
        left: 0,
        position: 'absolute',
    },
    groupChildLayout: {
        height: 11,
        width: 66,
        top: 3,
        position: 'absolute',
    },
    groupChild4ShadowBox: {
        shadowOpacity: 1,
        elevation: 6,
        shadowRadius: 6,
        shadowOffset: {
            width: 0,
            height: 1,
        },
        position: 'absolute',
    },
    text1Typo: {
        fontWeight: '700',
        color: '#00682C',
    },
    divider: {
        marginLeft: 12,
        borderWidth: 1,
        borderColor: '#F3F5FC',
        height: 10,
        width: 1,
        marginVertical: 4,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default LoanForeclosure;
